import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':attachmentId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/:attachmentId`;

export const URL = (attachmentId: number): RouteDefinition => `${baseRoute}/${attachmentId}`;
